__turbopack_context__.v({
  "btn-green": "index-module-scss-module__Urq51q__btn-green",
  "btn-modal-wrapper": "index-module-scss-module__Urq51q__btn-modal-wrapper",
  "btn-modal-wrapper-success": "index-module-scss-module__Urq51q__btn-modal-wrapper-success",
  "btn-red": "index-module-scss-module__Urq51q__btn-red",
  "btn-wrapper": "index-module-scss-module__Urq51q__btn-wrapper",
  "cancelDealModalBtns": "index-module-scss-module__Urq51q__cancelDealModalBtns",
  "content-list": "index-module-scss-module__Urq51q__content-list",
  "content-modal-wrapper": "index-module-scss-module__Urq51q__content-modal-wrapper",
  "content-wrapper": "index-module-scss-module__Urq51q__content-wrapper",
  "declineSelectItem": "index-module-scss-module__Urq51q__declineSelectItem",
  "form": "index-module-scss-module__Urq51q__form",
  "inner-wrapper": "index-module-scss-module__Urq51q__inner-wrapper",
  "list-item": "index-module-scss-module__Urq51q__list-item",
  "loader": "index-module-scss-module__Urq51q__loader",
  "modalBtn": "index-module-scss-module__Urq51q__modalBtn",
  "show-wrapper": "index-module-scss-module__Urq51q__show-wrapper",
  "table": "index-module-scss-module__Urq51q__table",
  "td": "index-module-scss-module__Urq51q__td",
  "th": "index-module-scss-module__Urq51q__th",
  "title-wrapper": "index-module-scss-module__Urq51q__title-wrapper",
  "wrapper": "index-module-scss-module__Urq51q__wrapper",
});
